import { gql } from '@apollo/client';

export const FETCH_FILE_SYSTEM_OBJECT_CONTENT = gql`
    query fetchFileSystemObjectContent($path: String) {
        facility {
            files(filter: { path: $path }) {
                content
            }
        }
    }
`;
